module.exports = __webpack_public_path__ + "img/nav-right-expand-search-kia.d81b9cc3.png";